import { MapSearchResult } from "../models/map-search.models";

export namespace MapSearchActions {
    export class SetSearchQuery {
        public static readonly type = "[MapSearch] Set search query";
        constructor(public searchQuery: string | undefined) {}
    }

    export class SelectSearchResult {
        public static readonly type = "[MapSearch] Select search result";
        constructor(public searchResult: MapSearchResult) {}
    }
}
